import packageJson from 'package.json';

export const appVersion = packageJson.version;
